"use client";

import { Bed, MapPin, MoveHorizontal } from "lucide-react";

export interface VehicleInfoBarProps {
  sleeps: number;
  length: string;
  location: string;
}

export function VehicleInfoBar({
  sleeps,
  length,
  location,
}: VehicleInfoBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-4 sm:gap-6 py-4 border-y border-gray-200 text-muted-foreground mb-8">
      <div className="flex items-center gap-2">
        <Bed className="h-5 w-5" />
        <span>Sleeps {sleeps}</span>
      </div>
      <div className="flex items-center gap-2">
        <MoveHorizontal className="h-5 w-5" />
        <span>{length}</span>
      </div>
      <div className="flex items-center gap-2">
        <MapPin className="h-5 w-5" />
        <span>{location}</span>
      </div>
    </div>
  );
}
